import { Col, FormGroup, Form, Row } from "react-bootstrap";
import FileUploader from "../../../../../@ui/FileUploader";
import {ErrorText} from "../../../../../@ui/ErrorText";
import {SnapshotWindow} from "../../../../../types/LayerAdmin/SnapshotWindow";

interface GtfsImportFieldsProps {
  values: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  errors: any;
  gtfsTouched: boolean;
  setGtfsTouched: (touched: boolean) => void;
  snapshotWindows: SnapshotWindow[];
}

const GtfsImportFields = ({
  values,
  handleChange,
  handleBlur,
  setFieldValue,
  errors,
  gtfsTouched,
  setGtfsTouched,
  snapshotWindows,
}: GtfsImportFieldsProps) => {
  return (
    <>
      <Row className="justify-content-center">
        <Col className="col-md-10">
          <FormGroup className="w-100 mt-2">
            <Form.Label>Upload GTFS Archive: </Form.Label>
            <FileUploader
              onClear={() => setFieldValue("gtfsFile", undefined)}
              onChange={(file) => {
                setFieldValue("gtfsFile", file);
              }}
              onBlur={(_) => setGtfsTouched(true)}
            />
          </FormGroup>
          {errors.gtfsFile && gtfsTouched && (
            <ErrorText className="text-danger">GTFS Archive is required</ErrorText>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col className="col-md-10">
          <FormGroup className="w-100 mt-2">
            <Form.Label>Import Quarter: </Form.Label>
            <Form.Select
              name="quarter"
              onChange={handleChange}
              value={values.quarter}
              onBlur={handleBlur}
            >
              <option value="">Select...</option>
              {snapshotWindows.map((window: any) => (
                <option key={window.quarter} value={window.quarter}>
                  {window.quarter}
                </option>
              ))}
            </Form.Select>
          </FormGroup>
          {errors.gtfsFile && gtfsTouched && (
            <ErrorText className="text-danger">GTFS Archive is required</ErrorText>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col className="col-md-10">
          <FormGroup className="w-100 mt-2">
            <Form.Label>Description: </Form.Label>
            <Form.Control
              name="gtfsName"
              onChange={handleChange}
              value={values.gtfsName}
              onBlur={handleBlur}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

export default GtfsImportFields;
